import React, { useState } from "react";
import { Title } from "rbx";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { GET_ALL_EMPLOYEES } from "./graphql";
import "../Reviews/Reviews.scss";
import { Loader, DetailedDataTable } from "../../components";
import { FOLLOWUPS_COLUMNS } from "./columns";
import FilterComponent from "../../components/DetailedDataTable/SearchFiltersModal";
import checkMobile from "../../utils/checkForMobile";

const AllWebEditorFollowups = () => {
  const [paginationWhere, setPaginationWhere] = useState({}); // eslint-disable-line
  const { data: employeeData, loading } = useQuery(GET_ALL_EMPLOYEES, {
    variables: {
      where: {},
    },
    fetchPolicy: "cache-and-network",
  });

  const isMobile = checkMobile();

  const users = employeeData?.users || [];

  const history = useHistory();

  const handleRowClick = (row) => {
    history.push(`/followups/${row.employeeNumber}`);
  };


  if (loading) {
    return (
      <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
        <div className="loader-container">
          <Loader />
        </div>
      </div>
    );
  }

  if (!users?.length > 0) {
    return (
      <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
        <div className="workshop">
          <Title>No Partners Found</Title>
        </div>
      </div>
    );
  }

  return (
    <div className={isMobile ? "workshop-container-mobile" : "workshop-container"}>
      <div className="workshop">
        <Title>All Partners</Title>
        <DetailedDataTable
          FilterComponent={FilterComponent}
          aggregateName="aggregateFollowup"
          columns={FOLLOWUPS_COLUMNS}
          dataExtractor={(data) => data?.users}
          defaultSorting={[{ id: "firstName", desc: false }]}
          location="followups"
          name="web-editor-followups"
          query={GET_ALL_EMPLOYEES}
          searchTransformer={(search) => ({})}
          setPaginationWhere={setPaginationWhere}
          totalExtractor={(total) => total}
          onRowClick={(user) => handleRowClick(user)}
        />
      </div>
    </div>
  );
};

export default AllWebEditorFollowups; 